export default __webpack_public_path__ + "static/media/title.5907989d.jpg";